export default "__VITE_ASSET__Dfhqc_yk__"